export default {
  "translation": {
    "card_application": "카드 신청",
    "card_application_des": "Sonic 카드를 받고 전 세계 4400만 개 이상의 Visa 승인 상점에서 사용하세요.",
    "spend_your_crypto_like_fiat": "암호화폐를 법정화폐처럼 사용하세요",
    "use_globally_across_borders": "전 세계 어디서나 사용하세요",
    "ultra_low_trans_costs": "초저 거래 비용",
    "seamless_and_secure": "원활하고 안전한",
    "two_factor_verification": "이중 인증",
    "two_factor_verification_des": "이메일, 전화, 생체 인식 및/또는 인증 앱을 사용하여 안전하게 로그인하세요",
    "safety_pin": "안전 PIN",
    "safety_pin_des": "PIN을 설정하여 개인 정보에 대한 접근을 제한하세요",
    "trans_3ds_verification": "3DS 인증",
    "trans_3ds_verification_des": "처리되기 전에 구매를 승인하세요",
    "additional_security": "추가 보안",
    "additional_security_des": "앱에서 카드 한도 및 기타 보안 기능을 쉽게 설정하세요",
    "get_your_redotpay_card_in_steps": "3단계로 Sonic 카드를 받으세요.",
    "get_your_redotpay_card_subtitle": "암호화폐를 법정화폐처럼 사용하세요: 전 세계 44M+ Visa 사용 가능 가맹점에서 사용 가능.",
    "continue_key": "계속",
    "bind_your_mobile_number": "휴대전화 번호 연결",
    "complete_identity_verification": "신원 확인 완료",
    "apply_a_virtual_or_physical_card": "가상 또는 물리 카드를 신청하세요",
    "transactions": "거래",
    "need_mobile_bind_confirm": "먼저 휴대폰을 연결해야 합니다",
    "info": "정보",
    "card_trans_status_refund_pending": "환불 대기 중",
    "card_trans_status_refund_success": "환불 성공",
    "card_trans_status_refund_fail": "환불 실패",
    "card_trans_status_refund_wait": "환불 대기 중",
    "card_trans_status_pending": "승인됨",
    "card_trans_status_cleared": "정리됨",
    "card_trans_status_declined": "거부됨",
    "card_trans_status_canceled": "취소됨",
    "card_trans_status_refund": "환불",
    "card_trans_status_refund_cancel": "환불 취소",
    "refund": "환불",
    "transaction_list": "거래 목록",
    "more": "더보기",
    "top_questions": "자주 묻는 질문",
    "faq": "FAQ",
    "self_service": "셀프 서비스",
    "support_center": "지원 센터",
    "hello": "안녕하세요",
    "updated_on": "업데이트 일자",
    "chat_with_us": "채팅하기",
    "warning": "경고",
    "security_option_change_alert_prompt": "Google Authenticator/모바일/이메일/PIN의 연결 해제/수정 후에는 보안상의 이유로 인출 및 내부 이체가 비활성화되며, 카드 거래는 다음 24시간 동안 거래당 $1000으로 제한됩니다.",
    "cancel": "취소",
    "ok": "확인",
    "account_deletion_regret_promp": "계정 삭제는 15일간의 후회 기간을 제공합니다. 삭제를 신청한 후 15일 이내에 다시 로그인하면 신청이 취소되고 계정을 정상적으로 사용할 수 있습니다.",
    "view_on_blockchain_explorer": "블록체인 탐색기에서 보기",
    "biz_sn": "거래 번호",
    "type": "유형",
    "create_time": "생성 시간",
    "logout_confirm": "정말 로그아웃 하시겠습니까?",
    "wallet": "지갑",
    "continue_with_google": "Google로 계속하기",
    "insufficient_balance_deposit_guide": "잔액 부족. 자산을 입금하지 않으면 거래가 거부되고 수수료가 부과될 수 있습니다.",
    "to": "-",
    "bill_will_be_sent_to": "청구서가 전송됩니다",
    "bill_statement": "청구서 명세서",
    "export_bill": "청구서 명세서 내보내기",
    "this_month": "이번 달",
    "last_month": "지난 달",
    "last_3_month": "지난 3개월",
    "this_year": "올해",
    "last_year": "작년",
    "customize": "사용자 정의",
    "bill_export_success": "청구서 명세서가 귀하의 이메일로 전송되었습니다. 확인해 주세요",
    "bill_empty": "귀하의 청구서가 비어 있습니다",
    "channel": "채널",
    "merchant_country": "상인 국가",
    "status": "상태",
    "withdraw_detail": "인출 세부정보",
    "new_key": "새로운",
    "deposit": "입금",
    "withdraw": "인출",
    "single_limit": "단일 한도",
    "all": "모두",
    "minimum": "최소",
    "available": "사용 가능",
    "received_amount": "수신 금액",
    "withdrawl": "인출",
    "network_fee": "네트워크 수수료",
    "register": "등록",
    "register_login": "등록/로그인",
    "login": "로그인",
    "email_Phone": "이메일/전화번호",
    "email": "이메일",
    "mobile": "휴대전화",
    "next": "다음",
    "or_continue_with": "또는 계속하기",
    "forgot_pw": "비밀번호를 잊으셨나요?",
    "welcome_to_redotpay": "Sonic Pay에 오신 것을 환영합니다",
    "verify_code": "인증 코드",
    "get_code": "코드 받기",
    "by_creating_an_account": "계정을 생성함으로써 귀하는 우리의",
    "privacy_policy": "정책",
    "terms_conditions": "약관",
    "and": "그리고",
    "modify_pin": "PIN 변경",
    "pin_subtitle": "보안 PIN은 빠른 인증을 제공하여 카드 번호 및 CVV 정보를 쉽게 볼 수 있도록 합니다.",
    "password_set_first_login": "첫 로그인 시 비밀번호 설정",
    "next_step": "다음 단계",
    "confirm": "확인",
    "username": "사용자 이름",
    "password": "비밀번호",
    "send_code": "코드 보내기",
    "send_code_to": "코드는 다음으로 전송됩니다",
    "switch_option": "인증 옵션 변경",
    "mobile_verification": "휴대전화 인증",
    "email_verification": "이메일 인증",
    "choose_verify_method": "인증 옵션 변경",
    "verify_pin": "보안 PIN",
    "google_authenticator_verification": "Google Authenticator",
    "security": "보안",
    "bound": "연결됨",
    "unbound": "연결되지 않음",
    "set": "설정",
    "unset": "해제",
    "update_pw": "비밀번호 변경",
    "delete_account": "계정 삭제",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticator는 귀하의 인출 및 계정을 보호합니다.",
    "download_install": "다운로드",
    "download_install_prompt": "먼저 Authenticator 앱(Google Authenticator)을 다운로드하여 설치해야 합니다.",
    "backup_key": "백업 키",
    "save_backup_key": "이 백업 키를 안전한 장소에 저장하세요",
    "google_authenticator_code": "Google Authenticator 코드",
    "email_subtitle": "이메일 인증은 귀하의 인출 및 계정을 보호합니다.",
    "change_email": "이메일 변경",
    "email_update": "이메일 업데이트",
    "code": "코드",
    "mobile_subtitle": "모바일 인증은 귀하의 인출 및 계정을 보호합니다.",
    "change_mobile": "모바일 변경",
    "mobile_update": "모바일 업데이트",
    "mobile_bind": "휴대전화 연결",
    "email_bind": "이메일 연결",
    "old_password": "이전 비밀번호",
    "new_password": "새 비밀번호",
    "new_password_confirm": "새 비밀번호 확인",
    "language": "언어",
    "appearance": "모양",
    "logout": "로그아웃",
    "log_out_toast": "로그아웃되었습니다",
    "set_pin": "보안 PIN",
    "account_deletion_prompt_1": "이 계정은 복구할 수 없습니다",
    "account_deletion_prompt_2": "이 계정으로 생성된 모든 하위 사용자/다른 계정이 삭제되며 복구할 수 없습니다.",
    "account_deletion_prompt_3": "이 계정과 관련된 모든 API 키가 삭제됩니다.",
    "account_deletion_prompt_4": "이 계정의 모든 현재 위임 및 보류 중인 통화 인출이 취소됩니다.",
    "account_deletion_prompt_5": "이 계정의 모든 거래 기능이 비활성화됩니다.",
    "account_deletion_prompt_6": "이 계정에서 인출되지 않은 자산은 자발적으로 포기된 자산으로 간주됩니다.",
    "account_deletion_prompt_7": "계정 삭제 요청 후 15일의 인출 기간이 있습니다. 삭제 요청 후 15일 이내에 다시 로그인하면 요청이 취소되고 계정을 정상적으로 사용할 수 있습니다.",
    "kyc_status_0": "제출되지 않음",
    "kyc_status_1": "검증 중...",
    "kyc_status_2": "승인됨",
    "kyc_status_3": "감사 실패",
    "kyc_status_4": "재제출됨",
    "kyc_status_5": "상위에 제출",
    "personal_info_review": "개인 정보 검토",
    "additional_info_request": "추가 정보 요청",
    "verifying": "검증 중...",
    "form_submitted_will_review_asap_new": "귀하의 신청이 수동 검토를 위해 제출되었습니다. 이 과정은 일반적으로 3-5일이 소요되지만 가끔 더 걸릴 수 있습니다. 양해해 주시기 바랍니다.",
    "get_verified": "신원 확인",
    "kyc_verified": "사용자 신원 확인 완료",
    "approved": "승인됨",
    "not_able_to_submit_identity": "종합 검토 과정의 일환으로, 고객 알기(KYC) 및 자금 세탁 방지(AML) 절차를 완료하기 위해 추가 정보가 필요합니다.",
    "aml_review_failed": "신청을 진행하려면 아래 버튼을 클릭하여 자기 선언 양식을 액세스하고 작성해 주세요.",
    "aml_declaration_prompt": "요청된 양식을 다음 14일 이내에 제공하지 않으면 신청이 거부됩니다.",
    "verify_your_identity": "신원을 확인하세요",
    "get_identity_verified": "카드를 구매하고 사용하기 위해 신원을 확인하세요",
    "country_region": "국가/지역",
    "given_name": "이름",
    "surname": "성",
    "date_of_birth": "생년월일",
    "document_type": "문서 유형",
    "document_number": "문서 번호",
    "given_name_intl": "이름(국제)",
    "surname_intl": "성(국제)",
    "click_to_add_signature": "서명을 추가하려면 클릭하세요",
    "rewrite": "다시 쓰기",
    "submit": "제출",
    "save": "저장",
    "accounts_are_not_available": "계정을 사용할 수 없습니다",
    "abandon_assets": "{{amount}} {{currency}} 자산 포기",
    "account_deletion_successful": "계정 삭제 성공",
    "passwords_do_not_match": "비밀번호가 일치하지 않습니다",
    "password_reset_success": "비밀번호 재설정 성공",
    "password_confirm": "비밀번호 확인",
    "is_refund": "환불",
    "total_debt": "총 채무",
    "your_account_is_in_arrears": "귀하의 계정이 연체 상태입니다. 잔액을 정산하기 위해 충분한 자금을 입금해 주세요. 채무 상환 후 귀하의 계정/카드는 잔액이 ≥10 USD일 때 복구됩니다.",
    "repayment": "상환",
    "debit_record": "차감 기록",
    "no_data": "빈 데이터",
    "payment": "지불",
    "transaction_details": "거래 세부정보",
    "transaction_date": "거래 날짜",
    "transaction_id": "거래 ID",
    "view_linked_order": "연결된 주문 보기",
    "rights_interests": "권리 및 이자",
    "transaction_limit": "거래 한도",
    "deposit_withdraw": "입금 및 인출",
    "card_purchased_number": "구매 가능한 카드 수",
    "on_review_your_applicant": "귀하의 신청서를 검토하고 있습니다",
    "form_en_only": "양식은 영어로만 작성할 수 있습니다",
    "available_to_spend": "사용 가능 금액",
    "get_a_card": "Sonic 카드를 받고 전 세계 4400만 개 이상의 Visa 승인 상점에서 사용하세요.",
    "virtual_card": "가상 카드",
    "physical_card": "물리 카드",
    "apply_card": "카드 신청",
    "enjoy_seamless_spending": "사용하세요",
    "spend_and_withdraw": "사용 및 ATM 인출",
    "card_labeling": "카드 라벨링",
    "card_tag": "카드 태그",
    "edit_billing_address": "청구 주소",
    "government_issued_id": "정부 발급 ID",
    "facial_recognition": "얼굴 인식",
    "address": "주소",
    "personnel_information_details": "인사 정보 세부사항",
    "nation_list": "국가 목록",
    "choose_channel": "인증 모드",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "카드 신청 주문",
    "promo_code_optional": "프로모션 코드 (선택 사항)",
    "promo_code": "프로모션 코드",
    "billing_address": "청구 주소",
    "shipping_address": "배송 주소",
    "shipping_to": "배송지",
    "card_purchase_fee": "카드 구매 수수료",
    "card_holder_name": "카드 소지자 이름",
    "city": "도시",
    "province_state": "주/도",
    "postal_code": "우편번호",
    "address_line1": "주소",
    "address_line2": "주소 2",
    "please_fill_in_the_information_in_english": "양식은 영어로만 작성할 수 있습니다",
    "first_name": "이름",
    "last_name": "성",
    "country_code": "국가 코드",
    "card_application_list": "카드 신청 목록",
    "buy_virtual_card": "가상 카드 구매",
    "buy_physical_card": "물리 카드 구매",
    "withdraw_list": "인출 목록",
    "no_more_data": "더 이상 데이터가 없습니다",
    "select_a_network": "네트워크 선택",
    "please_select_network": "네트워크를 선택해 주세요",
    "select_a_network_ensure": "입금할 네트워크가 출금 네트워크와 일치하는지 확인하세요. 그렇지 않으면 자산이 손실될 수 있습니다.",
    "network": "네트워크",
    "card_management": "카드 관리",
    "freeze": "동결",
    "unfreeze": "해제",
    "freeze_card_des": "원키 카드 잠금 기능이 활성화되면 이 카드를 사용할 수 없지만 다른 카드에는 영향을 미치지 않습니다. 원키 카드 잠금 기능을 취소하려면 여기에서 다시 활성화할 수 있습니다.",
    "freezing_trades": "카드를 동결하면 주문이 실패하여 거래 실패 또는 거부된 거래에 대한 추가 수수료가 발생할 수 있습니다.",
    "unfreeze_your_card_desc": "원키 카드 잠금 기능이 비활성화되면 이 카드를 다시 사용할 수 있으며 다른 카드에는 영향을 미치지 않습니다. 카드를 동결하려면 여기에서 다시 할 수 있습니다.",
    "card_tag_set_success": "카드 태그가 성공적으로 설정되었습니다",
    "bill": "청구서",
    "setting": "설정",
    "limit": "한도",
    "assets_list": "자산 목록",
    "empty_data": "빈 데이터",
    "deposit_list": "입금 목록",
    "date": "날짜",
    "merchant_city": "상점 도시",
    "card_number": "카드 번호",
    "card_type": "카드 유형",
    "mcc": "MCC",
    "declined_reason": "거부 사유",
    "card_authorization_payment": "카드 승인 결제",
    "declined_transaction_fee": "거부된 거래 수수료",
    "verified": "확인됨",
    "notifications": "알림",
    "need_to_add_bill_address": "청구 주소를 추가해야 합니다",
    "need_to_add_shipping_address": "배송 주소는 비워둘 수 없습니다",
    "success": "성공",
    "welcome_redotpay": "Sonic Pay에 오신 것을 환영합니다!",
    "reset_pw_alert": "비밀번호를 변경한 후, 출금 및 내부 이체가 비활성화되며 카드 거래는 다음 24시간 동안 거래당 $1000로 제한됩니다.",
    "no_more_records": "더 이상 기록이 없습니다",
    "add": "추가",
    "address_label": "주소 레이블",
    "add_address": "주소 추가",
    "this_field_is_required": "이 필드는 필수입니다",
    "ID_CARD": "신분증",
    "PASSPORT": "여권",
    "DRIVERS": "운전 면허증",
    "RESIDENCE_PERMIT": "거주 허가증",
    "amount": "금액",
    "withdraw_status_waiting": "대기 중",
    "withdraw_status_pending": "보류 중",
    "withdraw_status_success": "성공",
    "withdraw_status_fail": "실패",
    "withdraw_status_canceled": "취소됨",
    "withdraw_status_declined": "거부됨",
    "withdraw_status_complete": "완료",
    "order_id": "주문 ID",
    "click_or_scroll_to_load_more": "더 불러오려면 클릭하거나 스크롤하세요",
    "minimum_deposit_amount": "최소 입금 금액",
    "deposit_arrival_confirmations": "입금 도착: {{confirmations}} 확인",
    "confirmations": "{{confirmations}} 확인",
    "deposit_network": "입금 네트워크",
    "minimum_deposit": "최소 입금",
    "deposit_arrival": "입금 도착",
    "current_address_supports_depositing": "현재 주소는 {{displayName}}에서 {{varietyCode}} 입금만 지원하며, 다른 자산은 손실될 수 있습니다.",
    "copy_successful": "복사 성공",
    "update_password_successful": "비밀번호 업데이트 성공",
    "update_successful": "업데이트 성공",
    "successful": "성공",
    "signature_required": "서명 필요",
    "deposit_successful": "입금 성공",
    "sign_out": "로그아웃",
    "cancel_withdraw_order_success": "출금 주문 취소 성공",
    "delete_successful": "삭제 성공",
    "unfreeze_card_successful": "카드 해제 성공",
    "card_nickname_set_success": "카드 별명 설정 성공",
    "trans_limit_adjusted_success": "거래 한도 조정 성공",
    "set_card_pin_success": "카드 PIN 설정 성공",
    "withdraw_apply_commit_please_wait": "출금 신청이 제출되었습니다. 잠시 기다려 주세요",
    "unfreeze_success": "해제 성공",
    "freeze_success": "동결 성공",
    "withdraw_duration_tip": "출금 신청은 영업일 내에 처리됩니다",
    "you_will_withdraw": "당신은 인출합니다",
    "withdraw_info": "인출 정보",
    "please_confirm_same_network": "입금할 네트워크가 입금 네트워크와 일치하는지 확인하세요. 그렇지 않으면 자산이 손실될 수 있습니다.",
    "cancel_withdraw_order_confirm": "정말로 출금을 취소하시겠습니까?",
    "valid_thru": "유효기간",
    "last_7_days": "지난 7일",
    "last_30_days": "지난 30일",
    "today": "오늘",
    "all_done": "모두 완료",
    "view_details": "상세 보기",
    "withdraw_success": "출금 성공",
    "pay": "지불",
    "fee": "수수료",
    "discount": "할인",
    "price": "가격",
    "card_application_details": "카드 신청 세부정보",
    "card_pin": "카드 PIN",
    "card_pin_format_helper": "세 개의 연속된 동일한 숫자 또는 순차적인 숫자를 포함할 수 없습니다",
    "digit_variable": "{{count}} 자리",
    "address_book": "주소록",
    "unlimited": "무제한",
    "single": "단일",
    "update_card_pin": "카드 PIN 업데이트",
    "set_card_pin": "카드 PIN 설정",
    "report_lost": "분실 신고",
    "report_lost_card": "분실 카드 신고",
    "card_lost_report_alert": "분실 신고 후 카드가 비활성화되며 상태를 변경할 수 없습니다. 카드를 다시 사용하거나 새 카드를 신청하려면 고객 서비스 팀에 문의해 주세요.",
    "pending": "보류 중",
    "frozen": "동결됨",
    "phone_number": "전화번호",
    "search": "검색",
    "reset": "재설정",
    "total_amount": "총 금액",
    "actual_amount": "실제 금액",
    "already_have_an_account": "이미 계정이 있습니까?",
    "create_account": "Sonic Pay 계정 만들기",
    "total_balance": "총 잔액",
    "cards_balance_available_promp": "지갑 자산에 기반하여 실시간으로 계산된 신용 한도",
    "got_it": "알겠습니다",
    "review_details": "세부정보 검토",
    "delete_this_address": "이 주소를 삭제하시겠습니까?",
    "currency": "통화",
    "merchant_name": "상점 이름",
    "request_time": "요청 시간",
    "is_transaction_allowed": "이 거래가 허용되나요?",
    "approve": "승인",
    "decline": "거부",
    "card_in_production": "카드 제작 중",
    "redotpay_card_sent": "Redotpay 카드 발송됨",
    "redotpay_card_activated": "Redotpay 카드 활성화됨",
    "activate_card": "카드 활성화",
    "paste": "붙여넣기",
    "fees_included": "포함된 수수료",
    "fx_fee": "외환 수수료",
    "small_auth_fee": "소액 거래 수수료",
    "atm_fee": "ATM 수수료",
    "received": "받은",
    "incremental": "증가하는",
    "bill_address_save_success": "請求서 주소 저장 성공",
    "no_more_trans_record": "거래 기록 없음",
    "withdraw_amount_larger_than_available": "최대 사용 가능 잔고를 초과합니다",
    "withdraw_lower_than_min": "최소 출금액을 미만합니다",
    "card_is_deleted": "카드가 삭제되었습니다",
    "something_error": "잘못 됐습니다",
    "home": "홈",
    "select_country": "국가 선택",
    "billing_list": "請求서 목록",
    "coupon_code": "쿠폰 코드",
    "password_rule1": "8자에서 32자까지",
    "password_rule2": "영어 대문자 1개 이상",
    "password_rule3": "영어 소문자 1개 이상",
    "password_rule4": "숫자 1개 이상",
    "set_pw": "암호 설정",
    "payment_currency_settings": "결제 통화 설정",
    "customize_payment_currency": "결제 통화 사용자 지정",
    "disable_non_local_tip": "비현지 통화 거래를 비활성화하면 카드 사기 위험을 효과적으로 줄일 수 있습니다.",
    "charging_rules": "청구 규칙",
    "reissue_card": "카드 재발급",
    "update_cvv": "CVV 코드 업데이트",
    "update_cvv_desc": "동일한 카드 번호에 새 CVV 코드와 새 만료 날짜가 포함됩니다.",
    "reissue_fee": "재발급 수수료",
    "fx_fee_desc": "외환 수수료(FX 수수료)는 비기본 통화 거래 수수료 1.2%를 포함합니다(해당되는 경우).",
    "atm_fee_desc": "ATM 출금당 추가 수수료 2%가 부과됩니다.",
    "remit_fee_desc": "Visa 신용카드 또는 직불카드 사용 수수료.",
    "risk_safety_tips": "보안 팁",
    "risk_safety": "보안상의 이유로 관련 작업을 진행하기 전에 앱에서 얼굴 인증을 완료하십시오.",
    "go_to_app_verify": "앱에서 인증 진행",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "RedotPay로 바로 이동",
    "close": "닫기",
    "card_cancellation": "카드 취소",
    "delete_card": "카드 삭제",
    "delete_card_desc": "삭제 후 카드는 사용할 수 없으며, 이 작업은 되돌릴 수 없습니다.",
    "deleting_fee": "삭제 수수료",
    "currency_tips": "통화 팁",
    "at_least_one_currency": "적어도 하나의 결제 가능한 통화를 유지하십시오.",
    "all_select_currency": "이미 모든 통화로 거래를 지원합니다.",
    "small_auth_transaction_fee_stas": "소액 거래 수수료 세부정보",
    "small_transactions_this_month": "이번 달 소액 거래",
    "small_autn_trans_remain": "이번 달 소액 거래 수수료 면제 횟수",
    "rules": "규칙",
    "failed_rules": "거래 실패는 불량 거래 기록을 증가시키며, 초과 시 추가 수수료가 부과됩니다. 거래를 적절히 관리하십시오.",
    "rule_item": "항목",
    "free_count": "무료 횟수",
    "fees": "수수료",
    "declined_trans_remain": "이번 달 거절 거래 수수료 면제 횟수",
    "declined_transaction_fee_stats": "거절 거래 수수료 통계",
    "declined_rules": "거래 실패는 불량 거래 기록을 증가시키며, 초과 시 추가 수수료가 부과됩니다. 거래를 적절히 관리하십시오.",
    "declined_transactions_this_month": "이번 달 거절된 거래 수",
    "card_trans_detail_status_refund": "환불 처리 중",
    "card_trans_status_reversal": "취소",
    "card_trans_status_fully_refund": "처리 완료, 전체 환불",
    "card_trans_status_partial_refund": "처리 완료, 부분 환불",
    "card_trans_status_void": "무효",
    "first_time_free": "첫 번째는 무료",
    "FxFee": "외환 수수료",
    "AtmFee": "ATM 수수료",
    "RemitFee": "송금 수수료",
    "MccFee": "MCC 수수료",
    "mcc_fee_desc": "일부 상인은 거래 금액의 1.5%의 추가 수수료를 부과합니다. 수수료가 0.5 USD 미만인 경우 최소 0.5 USD의 수수료가 적용됩니다.",
    "please_deposit": "입금하십시오",
    "special_mcc_fee": "특수 MCC 수수료",
    "bank_verifying": "이 환불은 은행에서 검토 중입니다…",
    "estimate_time": "도착 예상 시간: 2~30일",
    "delete_out": "로그아웃",
    "card_is_loss": "카드가 분실 신고되었습니다",
    "incremental_desc": "승인 금액이 부족할 경우 추가 요금이 발생하며, 해당 금액은 정산 시 추가됩니다.",
    "card_trans_status_fully_refund1": "정산 완료",
    "card_trans_status_fully_refund2": "전액 환불",
    "card_trans_status_partial_refund1": "정산 완료",
    "card_trans_status_partial_refund2": "부분 환불",
    "review_takes_time": "검토는 2분에서 24시간이 걸립니다.",
    "custom_date_null": "사용자 지정 날짜를 선택하세요",
    "custom_date_error": "올바른 조회 시간을 설정해주세요",
    "small_trade_fee": "작은 거래 수수료",
    "user_risk_exception": "사용자 상태 예외",
    "request_exception": "요청 오류",
    "mobile_is_not_empty": "올바른 휴대폰 번호를 입력하십시오",
    "code_is_not_empty": "올바른 인증 코드를 입력하십시오",
    "browser_paste_error": "브라우저 제한 사항이 있습니다. 직접 입력해 주세요."
  }
};